import type { FC } from 'react';

import { temaDoModelo, type ModeloDoPdf } from '../../../logica/pdf/modelos';
import { corDoTemaFixo, type TokenDoTema } from '../../estilos/coresDoTema';
import styles from './ModeloDoPdf.module.scss';

// A MINIATURA DE CADA MODELO DO PDF, no banco de modelos: a capa em miniatura, desenhada em SVG com
// os tokens do tema do modelo (o Noite é escuro mesmo com a tela clara) e, quando o documento tem
// cores do artista (o branding), com elas. É a identidade dele que aparece na escolha.

const L = 120;
const A = 170;

export const MiniaturaDoPdf: FC<{ modelo: ModeloDoPdf; cores: string[] }> = ({ modelo, cores }) => {
  const tema = temaDoModelo(modelo);
  const cor = (t: TokenDoTema) => corDoTemaFixo(tema, t);
  const faixa = cores.length ? cores : [cor('layerAccent01')];
  const passo = L / faixa.length;
  const linhas = (x: number, y: number, larguras: number[]) => larguras.map((w, i) => <rect key={i} x={x} y={y + i * 7} width={w} height={3} rx={1.5} fill={cor('textSecondary')} />);
  return (
    <svg className={styles.miniaturaDoPdf} viewBox={`0 0 ${L} ${A}`} role='img' aria-hidden='true' focusable='false'>
      <rect width={L} height={A} fill={cor('background')} />
      {modelo === 'classico' && (
        <>
          <circle cx={30} cy={56} r={16} fill={cor('layerAccent01')} />
          <rect x={14} y={82} width={64} height={7} rx={2} fill={cor('textPrimary')} />
          {linhas(14, 96, [52, 40])}
          {faixa.map((c, i) => <rect key={`${c}-${i}`} x={i * passo} y={A - 14} width={passo} height={14} fill={c} />)}
        </>
      )}
      {modelo === 'noite' && (
        <>
          {faixa.map((c, i) => <rect key={`${c}-${i}`} x={i * passo} y={0} width={passo} height={4} fill={c} />)}
          <rect x={14} y={30} width={44} height={44} fill={cor('layerAccent01')} />
          <rect x={14} y={88} width={84} height={10} rx={2} fill={cor('textPrimary')} />
          <rect x={14} y={102} width={60} height={10} rx={2} fill={cor('textPrimary')} />
          {linhas(14, 122, [48, 36])}
        </>
      )}
      {modelo === 'revista' && (
        <>
          <rect width={L} height={74} fill={faixa[0]} />
          <circle cx={L / 2} cy={74} r={26} fill={cor('background')} />
          <circle cx={L / 2} cy={74} r={22} fill={cor('layerAccent01')} />
          <rect x={22} y={112} width={76} height={8} rx={2} fill={cor('textPrimary')} />
          {linhas(32, 128, [56, 40])}
          {faixa.map((c, i) => <rect key={`${c}-${i}`} x={14 + i * 12} y={A - 18} width={8} height={8} fill={c} />)}
        </>
      )}
    </svg>
  );
};
